import { render, staticRenderFns } from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=template&id=ddd6840e&scoped=true"
import script from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=script&lang=ts"
export * from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=script&lang=ts"
import style0 from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=style&index=0&id=ddd6840e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd6840e",
  null
  
)

export default component.exports